import _ from "lodash";
import React, { useState, useEffect } from "react";

import { Route, Switch, Redirect, useRouteMatch } from "react-router-dom";
import { Error400 } from "views/pages";
import IntlMessages from "util/intlMessages";
import AccountsTable from "./Table";
import { PageTitle } from "components/standart";
import AddAccount from "./Add";
import AccountInfo from "./Info";
import { path } from "./init";

const TelegramAccounts = (props) => {
  const { url, path } = useRouteMatch();
  const { breadCrumbs } = props;

  const contentInfo = (account) => {
    return `${url}/accounts_${account._id}`;
  };

  const contentForm = (account) => {
    return `${contentInfo(account)}/form`;
  };

  breadCrumbs.push({
    title: <IntlMessages id="Telegram.Accounts" />,
    url,
    actions: [<AddAccount {...{ contentForm }} />],
  });

  return (
    <Switch>
      <Route exact path={`${path}`}>
        <PageTitle {...breadCrumbs} />

        <AccountsTable {...{ contentInfo, contentForm }} />
      </Route>

      <Route path={`${path}/account_:accountId`}>
        <AccountInfo {...{ breadCrumbs, contentInfo, contentForm }} />
      </Route>

      <Route component={Error400} />
    </Switch>
  );
};

TelegramAccounts.path = path;

export default TelegramAccounts;
